<script lang="ts">
  import type { Snippet } from 'svelte';
  import { location, navigate } from './router.svelte';

  /**
   * React Router's <NavLink>: active when the location is `to` (with `end`) or below it, then marked
   * `aria-current="page"`; the class may depend on that. A plain click navigates right here, before
   * `onclick` runs, instead of leaving it to the page-wide `interceptLinks`: when `onclick` closes the
   * panel the link sits in, the link is already out of the page by then.
   */
  let {
    to,
    end = false,
    class: className,
    onclick,
    children,
  }: {
    to: string;
    end?: boolean;
    class: string | ((state: { isActive: boolean }) => string);
    onclick?: () => void;
    children: Snippet;
  } = $props();

  const isActive = $derived.by(() => {
    const path = location.pathname.length > 1 ? location.pathname.replace(/\/+$/, '') : location.pathname;
    if (path === to) return true;
    if (end) return false;
    return path.startsWith(to.endsWith('/') ? to : `${to}/`);
  });

  function click(e: MouseEvent) {
    if (!e.defaultPrevented && e.button === 0 && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey) {
      e.preventDefault();
      navigate(to);
    }
    onclick?.();
  }
</script>

<a
  href={to}
  aria-current={isActive ? 'page' : undefined}
  class={typeof className === 'function' ? className({ isActive }) : className}
  onclick={click}>{@render children()}</a
>
